import { ReactComponent as IconAtome } from '@assets/svg-icons/icon-atome.svg';
import { ReactComponent as IconAubLight } from '@assets/svg-icons/icon-aub-light.svg';
import { ReactComponent as IconBdo } from '@assets/svg-icons/icon-bdo.svg';
import { ReactComponent as IconBdoLight } from '@assets/svg-icons/icon-bdo-light.svg';
import { ReactComponent as IconBillease } from '@assets/svg-icons/icon-billease.svg'; // eslint-disable-line import/no-unresolved
import { ReactComponent as IconBpi } from '@assets/svg-icons/icon-bpi.svg';
import { ReactComponent as IconBpILight } from '@assets/svg-icons/icon-bpi-light.svg';
import { ReactComponent as IconCebuana } from '@assets/svg-icons/icon-cebuana.svg';
import { ReactComponent as IconCebuanaLight } from '@assets/svg-icons/icon-cebuana-light.svg';
import { ReactComponent as IconCoins } from '@assets/svg-icons/icon-coins.svg';
import { ReactComponent as IconCoinsLight } from '@assets/svg-icons/icon-coins-light.svg';
import { ReactComponent as IconCreditCards } from '@assets/svg-icons/icon-credit-cards.svg';
import { ReactComponent as IconCrypto } from '@assets/svg-icons/icon-crypto.svg';
import { ReactComponent as IconGcash } from '@assets/svg-icons/icon-gcash.svg';
import { ReactComponent as IconGooglePay } from '@assets/svg-icons/icon-google-pay.svg';
import { ReactComponent as IconGrabpay } from '@assets/svg-icons/icon-grabpay.svg';
import { ReactComponent as IconGrabpayLight } from '@assets/svg-icons/icon-grabpay-light.svg';
import { ReactComponent as IconLandbank } from '@assets/svg-icons/icon-landbank.svg';
import { ReactComponent as IconLandbankLight } from '@assets/svg-icons/icon-landbank-light.svg';
import { ReactComponent as IconMastercard } from '@assets/svg-icons/icon-mastercard.svg';
import { ReactComponent as IconMaya } from '@assets/svg-icons/icon-maya.svg';
import { ReactComponent as IconMayaLight } from '@assets/svg-icons/icon-maya-light.svg';
import { ReactComponent as IconMetrobank } from '@assets/svg-icons/icon-metrobank.svg';
import { ReactComponent as IconMetrobankLight } from '@assets/svg-icons/icon-metrobank-light.svg';
import { ReactComponent as IconMlhullier } from '@assets/svg-icons/icon-mlhullier.svg';
import { ReactComponent as IconMlhullierLight } from '@assets/svg-icons/icon-mlhullier-light.svg';
import { ReactComponent as IconOtc } from '@assets/svg-icons/icon-otc.svg';
import { ReactComponent as IconPaylaterLight } from '@assets/svg-icons/icon-paylater-light.svg';
import { ReactComponent as IconPaylaterLightWithTag } from '@assets/svg-icons/icon-paylater-with-tag.svg';
import { ReactComponent as IconPaymongo } from '@assets/images/paymongo-brandmark.svg';
import { ReactComponent as IconPineLabsPayInInstallments } from '@assets/svg-icons/icon-pine-labs-pay-in-installments.svg';
import { ReactComponent as IconQrph } from '@assets/svg-icons/icon-qrph.svg';
import { ReactComponent as IconRbank } from '@assets/svg-icons/icon-rbank.svg';
import { ReactComponent as IconRbankLight } from '@assets/svg-icons/icon-rbank-light.svg';
import { ReactComponent as IconRcbc } from '@assets/svg-icons/icon-rcbc.svg';
import { ReactComponent as IconRcbcLight } from '@assets/svg-icons/icon-rcbc-light.svg';
import { ReactComponent as IconShopeePay } from '@assets/svg-icons/icon-shopeepay.svg';
import { ReactComponent as IconSecurityBank } from '@assets/svg-icons/icon-security-bank.svg';
import { ReactComponent as IconSecurityBankLight } from '@assets/svg-icons/icon-security-bank-light.svg';
import { ReactComponent as IconSevenEleven } from '@assets/svg-icons/icon-seven-eleven.svg';
import { ReactComponent as IconSevenElevenLight } from '@assets/svg-icons/icon-seven-eleven-light.svg';
import { ReactComponent as IconStripe } from '@assets/svg-icons/icon-stripe.svg';
import { ReactComponent as IconStripeLight } from '@assets/svg-icons/icon-stripe-light.svg';
import { ReactComponent as IconUbp } from '@assets/svg-icons/icon-ubp.svg';
import { ReactComponent as IconUbpLight } from '@assets/svg-icons/icon-ubp-light.svg';
import { ReactComponent as IconUnionbank } from '@assets/svg-icons/icon-unionbank.svg';
import { ReactComponent as IconVisa } from '@assets/svg-icons/icon-visa.svg';
import { ReactComponent as IconVisaLight } from '@assets/svg-icons/icon-visa-light.svg';

export default {
  atome: IconAtome,
  aubLight: IconAubLight,
  bdo: IconBdo,
  bdoLight: IconBdoLight,
  billease: IconBillease,
  bpi: IconBpi,
  bpiLight: IconBpILight,
  cebuana: IconCebuana,
  cebuanaLight: IconCebuanaLight,
  coins: IconCoins,
  coinsLight: IconCoinsLight,
  crypto: IconCrypto,
  gcash: IconGcash,
  googlepay: IconGooglePay,
  grabpay: IconGrabpay,
  grabpayLight: IconGrabpayLight,
  landbank: IconLandbank,
  landbankLight: IconLandbankLight,
  mastercard: IconMastercard,
  maya: IconMaya,
  mayaLight: IconMayaLight,
  metrobank: IconMetrobank,
  metrobankLight: IconMetrobankLight,
  mlhuillier: IconMlhullier,
  mlhuillierLight: IconMlhullierLight,
  otc: IconOtc,
  paylaterLight: IconPaylaterLight,
  paylaterLightWithTag: IconPaylaterLightWithTag,
  paymongo: IconPaymongo,
  pineLabsPayInInstallments: IconPineLabsPayInInstallments,
  qrph: IconQrph,
  rbank: IconRbank,
  rbankLight: IconRbankLight,
  rcbc: IconRcbc,
  rcbcLight: IconRcbcLight,
  securityBank: IconSecurityBank,
  securityBankLight: IconSecurityBankLight,
  sevenEleven: IconSevenEleven,
  sevenElevenLight: IconSevenElevenLight,
  shopeepay: IconShopeePay,
  stripe: IconStripe,
  stripeLight: IconStripeLight,
  ubp: IconUbp,
  ubpLight: IconUbpLight,
  unionbank: IconUnionbank,
  visa: IconVisa,
  visaLight: IconVisaLight,
  visaMastercard: IconCreditCards
};
